import { Apple, Play } from 'lucide-react';
import { FadeIn } from './Reveal';
import { useLang } from '../i18n/LangContext';
import { APP_STORE_URL } from '../storeLinks';

const StoreButton = ({ icon: Icon, store, soon, soonTitle, testid, href }) => {
  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className="inline-flex items-center gap-3 rounded-2xl border border-krug-gold/50 bg-krug-gold/10 px-7 py-4 text-left hover:border-krug-goldbright hover:bg-krug-gold/20 transition-[border-color,background-color] duration-300"
      >
        <Icon size={26} className="text-krug-goldbright" />
        <span className="leading-tight">
          <span className="block text-[10px] uppercase tracking-[0.2em] text-slate-400">{soon}</span>
          <span className="block font-heading text-lg font-extrabold text-white">{store}</span>
        </span>
      </a>
    );
  }
  return (
    <button
      type="button"
      data-testid={testid}
      aria-disabled="true"
      title={soonTitle}
      className="inline-flex cursor-not-allowed items-center gap-3 rounded-2xl border border-white/15 bg-white/[0.04] px-7 py-4 text-left opacity-80 hover:opacity-100 hover:border-krug-gold/50 transition-[opacity,border-color] duration-300"
    >
      <Icon size={26} className="text-white" />
      <span className="leading-tight">
        <span className="block text-[10px] uppercase tracking-[0.2em] text-slate-500">{soon}</span>
        <span className="block font-heading text-lg font-extrabold text-white">{store}</span>
      </span>
    </button>
  );
};

export const StoreCTA = () => {
  const { t } = useLang();
  return (
  <section data-testid="store-cta-section" className="bg-krug-navy pb-24 md:pb-32">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <FadeIn>
        <div className="relative overflow-hidden rounded-[2.5rem] border border-krug-gold/25 bg-gradient-to-br from-krug-surface to-krug-deep px-8 py-16 md:py-20 text-center">
          <div className="absolute -top-28 left-1/2 -translate-x-1/2 w-[520px] h-[300px] rounded-full bg-krug-gold/15 blur-[120px]" aria-hidden="true" />
          <div className="absolute bottom-0 right-10 w-44 h-44 rounded-full border border-krug-teal/20" aria-hidden="true" />
          <span className="relative mx-auto inline-flex items-center justify-center w-20 h-20 rounded-full bg-white p-1.5 shadow-[0_0_44px_rgba(245,158,11,0.4)]">
            <img src="/assets/krug-logo.png" alt="KRUG logo" className="w-full h-full object-contain" />
          </span>
          <h2 data-testid="store-cta-title" className="relative mt-7 font-heading font-extrabold tracking-tight text-3xl md:text-5xl text-white">
            {t.store.titleA}<span className="text-gradient-gold">{t.store.titleB}</span>
          </h2>
          <p className="relative mt-4 text-sm md:text-base text-slate-400">{t.store.sub}</p>
          <div className="relative mt-9 flex flex-wrap justify-center gap-4">
            <StoreButton icon={Apple} store="App Store" soon={t.store.live} soonTitle={t.store.soonTitle} testid="store-cta-appstore" href={APP_STORE_URL} />
            <StoreButton icon={Play} store="Google Play" soon={t.store.soon} soonTitle={t.store.soonTitle} testid="store-cta-googleplay" />
          </div>
        </div>
      </FadeIn>
    </div>
  </section>
  );
};
